import React, { useEffect, useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { BsExclamationLg } from "react-icons/bs";

import { FaRegSquareCheck } from "react-icons/fa6";
import { fetchShoppers, verifyShopper } from "../../redux/slices/shopperSlice";
import { pushNotifyShopper } from "../../redux/slices/pushSlice";

export default function ModalVerifyShopper({ id, name }) {
  const [showModal, setShowModal] = useState(false);

  const status = useSelector((state) => state.shopper?.status);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    user_id: "",
  });

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      user_id: id,
    }));
  }, [id]);

  const handleVerify = async (e) => {
    e.preventDefault();
    console.log(formData);
    try {
      const res = await dispatch(verifyShopper(formData));
      if (res.payload) {
        const pushNote = {
          shopper_id: [id],
          title: "Capfields Evolve",
          body: "Your account is Approved.",
          click: "SHOPPER",
        };
        dispatch(pushNotifyShopper(pushNote));
      }
      await dispatch(fetchShoppers());
      setShowModal(false);
      toast.success(res.payload.message);
    } catch (error) {}
  };

  return (
    <>
      <div className=" flex items-center">
        <button
          type="button"
          onClick={() => setShowModal(true)}
          className="font-medium"
        >
          <FaRegSquareCheck className="text-green-600 text-lg" />
        </button>
      </div>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-5xl">
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className=" text-center mb-4">
                  <h1 className="text-2xl text-gray-800 text-center font-medium mb-4">
                    Approve Shopper
                  </h1>
                  <p>Do you want to Approve this shopper</p>
                </div>
                <div className="flex justify-center items-center m-2">
                  <BsExclamationLg className="text-gray-500 text-3xl font-bold" />
                </div>
                <div className="flex items-center px-8 py-4 gap-6">
                  <div className="flex flex-col gap-4">
                    <div className="flex flex-row gap-2 justify-center items-center">
                      <h1 className="text-[14px] text-left text-gray-400 ">
                        name :
                      </h1>
                      <div className="">
                        <p className=" text-base font-bold">{name}</p>
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="flex items-center">
                        <input
                          name="id"
                          type="hidden"
                          id="id"
                          value={id}
                          // onChange={handleChange}
                          className="pl-[12px] text-[#333843] p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
                        />
                      </div>
                    </div>
                    <div className="flex mt-2 gap-4 justify-center">
                      <button
                        onClick={() => setShowModal(false)}
                        className="text-sm text-gray-500 font-semibold bg-gray-100 py-2 px-4 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        className="flex gap-1 rounded-md items-center bg-green-600 text-white py-2 px-4"
                        disabled={status === "loading"}
                        onClick={handleVerify}
                      >
                        {status === "loading" ? (
                          <>
                            <FaSpinner className="animate-spin" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Approving ...
                            </p>
                          </>
                        ) : (
                          <>
                            <FaTimes className="w-4 h-4" />
                            <p className="text-sm font-semibold whitespace-nowrap">
                              Approve
                            </p>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
